import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=65079cc5&scoped=true&"
import script from "./packageList.vue?vue&type=script&lang=js&"
export * from "./packageList.vue?vue&type=script&lang=js&"
import style0 from "./packageList.vue?vue&type=style&index=0&id=65079cc5&scoped=true&lang=css&"
import style1 from "./packageList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65079cc5",
  null
  
)

export default component.exports